export class SessionStorage {
  static getItem<T>(key: string): T | undefined {
    try {
      const str = sessionStorage.getItem(key);
      if (!str) return undefined;
      return JSON.parse(str) as T;
      // eslint-disable-next-line sonarjs/no-ignored-exceptions
    } catch (_error) { // ignore error
      return undefined;
    }
  }

  static setItem(key: string, data?: unknown): void {
    if (data === undefined) {
      sessionStorage.removeItem(key);
    } else {
      sessionStorage.setItem(key, JSON.stringify(data));
    }
  }
}
